import type { PlayerDashboardEmptyContentProps } from '@/modules/players/v3/components/shared/dashboard-widget-card/player-dashboard-empty-content';

export const toWidgetErrorState = (
  {
    visual,
    mascotSlotClassName,
  }: Pick<PlayerDashboardEmptyContentProps, 'visual' | 'mascotSlotClassName'>,
  title: string,
  onRetry: () => void
): PlayerDashboardEmptyContentProps => ({
  title,
  description: 'Something went wrong. Please try again.',
  visual,
  mascotSlotClassName,
  cta: { label: 'Try again', variant: 'primary', onClick: onRetry },
});
